import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import isAuthenticated from '../../../redux/auth/authUtils';
import {
  closeExperienceForm,
  fetchUserExperiences,
  openFeedbackForm,
  updateUserExperience,
} from '../../../redux/feedback/feedback-slice';
import { useAppDispatch } from '../../../redux/store';
import { RootState } from '../../../redux/types';
import { UserExperience } from '../../../types/instant-lease-api';
import Modal from '../../b2b/components/modal/modal';
import RadioContainer from '../../b2b/components/radio-container/radio-container';
import Radio from '../../b2b/components/radio/radio';
import './snacker.css';

interface SnackerForm {
  experience: UserExperience.Experience;
}

const Snacker: React.FC = () => {
  const auth = useSelector((state: RootState) => state.auth);
  const { activeApplication } = useSelector(
    (state: RootState) => state.leaseApp,
  );
  const { experienceForm } = useSelector((state: RootState) => state.feedback);
  const dispatch = useAppDispatch();
  const { watch, setValue, handleSubmit } = useForm<SnackerForm>();

  useEffect(() => {
    activeApplication?.customer?.uuid &&
      dispatch(fetchUserExperiences({ auth }));
  }, []);

  const close = () => dispatch(closeExperienceForm());

  const options = [
    { value: 'a', label: 'Nicht so gut', icon: '😖' },
    { value: 'b', label: 'Uff war ok', icon: '😐' },
    { value: 'c', label: 'War supi dupi', icon: '🤩' },
  ];

  const submitData = ({ experience }: SnackerForm) => {
    activeApplication?.uuid &&
      dispatch(
        updateUserExperience({
          accessToken: auth.accessToken,
          leaseApplicationId: activeApplication?.uuid,
          experience,
        }),
      )
        .then(close)
        .then(() => dispatch(openFeedbackForm()));
  };

  return isAuthenticated(auth) && activeApplication?.uuid ? (
    <div className='snacker'>
      <Modal
        className='snacker'
        isOpen={experienceForm.isOpened}
        onClose={close}
        type='middle'
        direction='up'
        background='transparent'
      >
        <h1 className='title'>Wie war deine Experience?</h1>
        <form>
          <RadioContainer>
            {options.map(({ value, label, icon }) => (
              <div key={value}>
                <Radio
                  value={watch('experience') || ''}
                  checked={watch('experience') === value}
                  onChange={() => {
                    setValue('experience', value as UserExperience.Experience);
                    handleSubmit(submitData)();
                  }}
                >
                  {icon}
                </Radio>
                <p className='content-normal'>{label}</p>
              </div>
            ))}
          </RadioContainer>
        </form>
      </Modal>
    </div>
  ) : null;
};

export default Snacker;
